// TODO: Get rid of this package (bug #117775)

import { LazyImport, LazyBootModule } from 'owa-bundling-light';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "OwaHierarchyOperations" */ './lazyIndex')
);

export const lazyFolderHierarchyDocument = new LazyImport(
    lazyModule,
    m => m.FolderHierarchyDocument
);
